"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialValues = void 0;
var react_1 = require("react");
var useInitialValues = function () {
    return (0, react_1.useMemo)(function () { return ({
        remember: true,
    }); }, []);
};
exports.useInitialValues = useInitialValues;
